import React from "react";
import "./WhatsAppButton.css";
import { FaWhatsapp } from "react-icons/fa";

function WhatsAppButton() {
  return (
    <div className="whatsapp-container">
      <a
        href="https://wa.me/919886003080"
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-button"
      >
        <FaWhatsapp />
      </a>
    </div>
  );
}

export default WhatsAppButton;
